import axios from 'axios';
import config from '@/config/constants.js';
import { firebase } from '@/config/firebase';

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
    failedQueue.forEach(({ resolve, reject }) => {
        if (error) {
            reject(error);
        } else {
            resolve(token);
        }
    });
    failedQueue = [];
}

export function setupAxiosInterceptor(store) {
    axios.interceptors.response.use(
        response => response,
        async error => {
            const originalRequest = error.config;

            if (
                error.response &&
                error.response.status === 401 &&
                error.response.data &&
                error.response.data.code === 'TOKEN_EXPIRED' &&
                !originalRequest._retry
            ) {
                if (isRefreshing) {
                    return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject });
                    }).then(token => {
                        originalRequest.headers['Authorization'] = token;
                        return axios(originalRequest);
                    });
                }

                originalRequest._retry = true;
                isRefreshing = true;

                try {
                    const firebaseUser = firebase.auth().currentUser;
                    if (!firebaseUser) {
                        store.commit('Authenticate/logout');
                        processQueue(new Error('No Firebase session'), null);
                        return Promise.reject(error);
                    }

                    const firebaseIdToken = await firebaseUser.getIdToken(true);
                    const tenantId = store.state.Authenticate.user
                        ? store.state.Authenticate.user.tenant_id || store.state.Authenticate.user.tenant_current_logged
                        : null;

                    const response = await axios.post(
                        config.api_url + 'user/refresh_token',
                        { tenant_id: tenantId },
                        {
                            headers: {
                                'X-Firebase-Token': firebaseIdToken,
                                'Content-Type': 'application/json'
                            }
                        }
                    );

                    const newToken = response.data.access_token;

                    store.commit('Authenticate/auth_success', {
                        access_token: newToken,
                        user: response.data.user,
                    });

                    processQueue(null, newToken);

                    originalRequest.headers['Authorization'] = newToken;
                    return axios(originalRequest);

                } catch (refreshError) {
                    processQueue(refreshError, null);
                    store.commit('Authenticate/logout');
                    return Promise.reject(refreshError);
                } finally {
                    isRefreshing = false;
                }
            }

            return Promise.reject(error);
        }
    );
}
